import React from 'react';

const SpinIcon = ({ fill, width, height }) => (
    <svg className="icon icon-spin" width={width} height={height} viewBox="0 0 20 20">
        <path
            fill={fill}
            d="M17 2c1.657 0 3 1.343 3 3v14c0 1.657-1.343 3-3 3H3c-1.657 0-3-1.343-3-3V5c0-1.657 1.343-3 3-3h14zm0 1.5H3c-.78 0-1.42.595-1.493 1.356L1.5 5v14c0 .78.595 1.42 1.356 1.493L3 20.5h14c.78 0 1.42-.595 1.493-1.356L18.5 19V5c0-.78-.595-1.42-1.356-1.493L17 3.5zm-12 12c.828 0 1.5.672 1.5 1.5s-.672 1.5-1.5 1.5-1.5-.672-1.5-1.5.672-1.5 1.5-1.5zm10 0c.828 0 1.5.672 1.5 1.5s-.672 1.5-1.5 1.5-1.5-.672-1.5-1.5.672-1.5 1.5-1.5zm-5-5c.828 0 1.5.672 1.5 1.5s-.672 1.5-1.5 1.5-1.5-.672-1.5-1.5.672-1.5 1.5-1.5zm5-5c.828 0 1.5.672 1.5 1.5s-.672 1.5-1.5 1.5-1.5-.672-1.5-1.5.672-1.5 1.5-1.5zm-10 0c.828 0 1.5.672 1.5 1.5S5.828 8.5 5 8.5 3.5 7.828 3.5 7 4.172 5.5 5 5.5z"
            transform="translate(-30 -921) translate(0 315) translate(20) translate(0 594) translate(10 10)"
        />
    </svg>
);

export default SpinIcon;
